import ax from "../../shared/utils/http_client"
import { currencyHelper } from "../utils/currency"

export const CartSummary = () => ({
  totalAmount: 0,
  discountAmount: 0,
  isLoading: true,
  currencySymbol: 'NT$',
  currencyCode: 'TWD',

  async init() {
    // 設定載入狀態
    this.isLoading = true

    const { currencyCode, currencySymbol } = await currencyHelper.loadCurrencyInfo()
    this.currencyCode = currencyCode
    this.currencySymbol = currencySymbol

    try {
      const response = await ax.get("/api/v1/cart")
      this.$store.frontend.setCart(response.data.cart)
    } catch (error) {
      console.error('載入購物車失敗：', error)
      // 如果無法載入購物車，設置一個空的購物車狀態
      this.$store.frontend.setCart({ items: [] })
    } finally {
      // 無論成功或失敗都結束載入狀態
      this.isLoading = false
    }

    this.$watch('discountAmount', () => {
      this.updateTotalAmount()
    })

    this.$watch('$store.frontend.cart.totalSelectedAmount', () => {
      this.updateTotalAmount()
    })
  },

  updateTotalAmount() {
    const cartTotal = this.$store.frontend.cart?.totalSelectedAmount || 0
    this.totalAmount = Math.max(0, cartTotal - this.discountAmount)
  },

  displayPrice(price, unit = null, skipConversion = false) {
    const numericPrice = Number(price || 0)
    const convertedPrice = skipConversion
      ? numericPrice
      : currencyHelper.convertPrice(numericPrice, 'TWD', this.currencyCode)
    const precision = currencyHelper.getCurrencyPrecision(this.currencyCode)

    const formattedValue = Number(convertedPrice || 0).toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    })

    const symbolToUse = unit || this.currencySymbol

    return `${symbolToUse} ${formattedValue}`.trim()
  },

  async displayPriceAsync(price, unit = null) {
    // 保留原本的異步版本，用於需要的地方
    return await currencyHelper.displayPrice(price)
  },

  get finalAmount() {
    const cartTotal = this.$store.frontend.cart?.totalSelectedAmount || 0
    return Math.max(0, cartTotal - this.discountAmount)
  },

  get isAmountExceeded() {
    // 服務商品訂單不受 NT$10,000 限制
    const allServiceProducts = this.$store.frontend.cart?.allServiceProducts || false
    if (allServiceProducts) {
      return false
    }

    // 用即時匯率將 10,000 TWD 門檻換算成顯示幣別
    const cartTotal = this.$store.frontend.cart?.totalSelectedAmount || 0
    const exchangeRate = this.$store.frontend.cart?.exchangeRate || 1
    return cartTotal > 10000 * exchangeRate
  },
})
